import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@creditas/typography'

const NoTeamFeedback: FC = () => {
  const { t } = useTranslation(['surprise'])

  return (
    <>
      <Typography variant="form">
        {t('feedbacks.no-team-on-surprise.title')}
      </Typography>
      <Typography variant="support">
        {t('feedbacks.no-team-on-surprise.message')}
      </Typography>
    </>
  )
}

export { NoTeamFeedback }
